import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root'
})
export class AuthApiService {
    private readonly authUrl = environment.cognito.authUrl;
    private readonly clientId = environment.cognito.clientId;

    constructor(private http: HttpClient) {}

    login(username: string, password: string): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/x-amz-json-1.1',
            'X-Amz-Target': 'AWSCognitoIdentityProviderService.InitiateAuth',
        });

        const body = {
            AuthParameters: {
                USERNAME: username,
                PASSWORD: password,
            },
            AuthFlow: 'USER_PASSWORD_AUTH',
            ClientId: this.clientId,
        };

        return this.http.post<any>(this.authUrl, body, { headers });
    }

    refresh(refreshToken: string): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/x-amz-json-1.1',
            'X-Amz-Target': 'AWSCognitoIdentityProviderService.InitiateAuth',
        });

        const body = {
            AuthParameters: {
                REFRESH_TOKEN: refreshToken,
            },
            AuthFlow: 'REFRESH_TOKEN_AUTH',
            ClientId: this.clientId,
        };

        return this.http.post<any>(this.authUrl, body, { headers });
    }
}
